module.exports = __webpack_public_path__ + "static/girl.a95478b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/girl.jpg
// module id = 1095
// module chunks = 35783957827783